import { render, staticRenderFns } from "./Bookmarks.vue?vue&type=template&id=69e30be0&scoped=true&"
import script from "./Bookmarks.vue?vue&type=script&lang=js&"
export * from "./Bookmarks.vue?vue&type=script&lang=js&"
import style0 from "./Bookmarks.vue?vue&type=style&index=0&id=69e30be0&lang=scss&scoped=true&"
import style1 from "./Bookmarks.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e30be0",
  null
  
)

export default component.exports